import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Col, Row, Table } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { BASE_URL } from "../../../services/Api";
import { authHeader } from "../../../services/auth-header";

const ViewAraiMFGSO = ({ enquiryData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerSearch, setCustomerSearch] = useState(encodeURIComponent(" "));
  const [productOptions, setProductOptions] = useState([]);
  const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
  const [customerDetailsOptions, setCustomerDetailsOptions] = useState();
  const [branchOptions, setBranchOptions] = useState();
  const [branchSearch, setBranchSearch] = useState(encodeURIComponent(" "));
  const [warehouseOptions, setWarehouseOptions] = useState();
  const [warehouseSearch, setWarehouseSearch] = useState(encodeURIComponent(" "));
  const [staffOptions, setStaffOptions] = useState();
  const [staffSearch, setStaffSearch] = useState(encodeURIComponent(" "));

  const [customerAddressValue, setCustomerAddressValue] = useState();
  const [branchValue, setBranchValue] = useState();
  const [warehouseValue, setWarehouseValue] = useState();
  const [customerNameValue, setCustomerNameValue] = useState();

  const [enquiryDetails, setEnquiryDetails] = useState({
    salesordertype: "Manufacturing",
    salesordercategory: "International",
    branch: "",
    warehouse: "",
    sodate: "",
    amendmentno: "",
    amendmentdate: "",
    customer: "",
    contactperson: "",
    contactno: "",
    email: "",
    customeraddress: "",
    customerpono: "",
    customerpodate: "",
    quotationno: "",
    quotationdate: "",
    netamountcurrency: "",
    netamount: "",
    exportpreperationchargescurrency: "",
    exportpreperationcharges: "",
    grandtotalcurrency: "",
    grandtotalinr: "",
    salesOrderItems: [],
    socurrency: "",
    soexchangerate: "",
  });

  console.log(enquiryData);

  async function getBranchData() {
    const response = await axios.get(`${BASE_URL}branch/page/0/5/asc/id/${branchSearch.length > 0 ? branchSearch : encodeURIComponent(" ")}`, {
      headers: authHeader(),
    });

    console.log(response);
    setBranchOptions(
      response.data.Index
        ? response.data.Index.map((customer) => ({
          value: customer.id,
          label: customer.branchname,
        }))
        : response.data.data.map((customer) => ({
          value: customer.id,
          label: customer.branchname,
        }))
    );
  }

  async function getWarehouseData() {
    try {
      const response = await axios.get(`${BASE_URL}warehouse/page/0/10/asc/id/${warehouseSearch.length > 0 ? warehouseSearch : encodeURIComponent(" ")}`, {
        headers: authHeader(),
      });
      console.log(response);
      setWarehouseOptions(
        response.data.Index
          ? response.data.Index.map((customer) => ({
            value: customer.id,
            label: customer.warehousename,
          }))
          : response.data.data.map((customer) => ({
            value: customer.id,
            label: customer.warehousename,
          }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function getStaffData() {
    try {
      const response = await axios.get(`${BASE_URL}staff/page/0/10/asc/id/${staffSearch.length > 0 ? staffSearch : encodeURIComponent(" ")}`, {
        headers: authHeader(),
      });
      console.log(response);
      setStaffOptions(
        response.data.Index
          ? response.data.Index.map((customer) => ({
            value: customer.id,
            label: customer.firstname + customer.lastname,
          }))
          : response.data.data.map((customer) => ({
            value: customer.id,
            label: customer.firstname + customer.lastname,
          }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerData() {
    try {
      const response = await axios.get(`${BASE_URL}customer/page/0/10/asc/id/${customerSearch.length > 0 ? customerSearch : encodeURIComponent(" ")}`, {
        headers: authHeader(),
      });
      setCustomerOptions(
        response.data.Index
          ? response.data.Index.map((customer) => ({
            value: customer.id,
            label: customer.companyname,
          }))
          : response.data.data.map((customer) => ({
            value: customer.id,
            label: customer.companyname,
          }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function getProductData() {
    try {
      const response = await axios.get(`${BASE_URL}product/page/international mfg/0/5/asc/id/${productSearch.length > 0 ? productSearch : encodeURIComponent(" ")}`, {
        headers: authHeader(),
      });

      setProductOptions(
        response.data.Index
          ? response.data.Index.map((product) => ({
            value: product.id,
            label: product.description,
          }))
          : response.data.data.map((product) => ({
            value: product.id,
            label: product.description,
          }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerDetails(id) {
    try {
      const response = await axios.get(`${BASE_URL}customer/findById/${id}`, {
        headers: authHeader(),
      });
      setEnquiryDetails({
        ...enquiryDetails,
        customer: {
          id: id,
        },
        contactperson: response.data.contactperson,
        contactno: response.data.contactno,
        email: response.data.email,
        customeraddress: response.data.address,
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function getCustomerAddress(id) {
    try {
      const response = await axios.get(`${BASE_URL}customerMultipleAddress/getAddress/${id}`, {
        headers: authHeader(),
      });

      console.log(response);
      setCustomerDetailsOptions(response.data.map((data) => ({ value: data.id, label: data.customeraddress })));
    } catch (error) { }
  }

  async function handleProductChange(event) {
    try {
      const response = await axios.get(`${BASE_URL}product/findById/${event.value}`, {
        headers: authHeader(),
      });

      console.log(response);

      let row = {
        product: {
          id: response.data.id,
        },
        description: response.data.description,
        itemcode: response.data.itemcode,
        hsnsacno: response.data.hsnsacno,
        uom: response.data.unitofmeasurement,
        currency: enquiryDetails?.socurrency,
        quantity: "",
        unitratecurrency: "",
        totalcurrency: "",
        exchangerate: enquiryDetails?.soexchangerate,
        unitrateinr: "",
        totalinr: "",
      };

      setEnquiryDetails({
        ...enquiryDetails,
        salesOrderItems: [...enquiryDetails.salesOrderItems, row],
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();

    try {
      const response = await axios.put(`${BASE_URL}salesOrder/update/${id}`, enquiryDetails, {
        headers: authHeader(),
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Enquiry added successfully!",
      });

      navigate("/salesOrderIndexTable/1");
    } catch (error) {
      console.log(error);
    }
  }

  const handleFormChange = (event, element) => {
    console.log("start");
    if (element === "soexchangerate") {
      let data = enquiryDetails;
      data.soexchangerate = event.target.value;
      const newItems = enquiryDetails.salesOrderItems.map((item) => ({
        ...item,
        exchangerate: event.target.value,
      }));

      data.salesOrderItems = newItems;
      console.log("start");
      setEnquiryDetails(data);
      console.log("start");
      calculationsBasedOnExchangeRate();
      return;
    }

    if (element === "socurrency") {
      const newItems = enquiryDetails.salesOrderItems.map((item) => ({
        ...item,
        currency: event.target.value, // Update currency for each item
      }));

      setEnquiryDetails({
        ...enquiryDetails,
        socurrency: event.target.value, // Update selected currency
        salesOrderItems: newItems, // Update all item currencies
      });
      return;
    }

    if (element === "branch") {
      setEnquiryDetails({
        ...enquiryDetails,
        branch: {
          id: event.value,
        },
      });
      setBranchValue(event);
      return;
    }

    if (element === "billto") {
      setEnquiryDetails({
        ...enquiryDetails,
        billto: {
          id: event.value,
        },
      });
      return;
    }

    if (element === "shipto") {
      setEnquiryDetails({
        ...enquiryDetails,
        shipto: {
          id: event.value,
        },
      });
      return;
    }

    if (element === "copyto") {
      let data = [];

      for (let i = 0; i < event.length; i++) {
        let obj = {
          id: event[i].value,
        };

        data.push(obj);
      }

      setEnquiryDetails({
        ...enquiryDetails,
        copyto: data,
      });
      return;
    }

    if (element === "warehouse") {
      setEnquiryDetails({
        ...enquiryDetails,
        warehouse: {
          id: event.value,
        },
      });
      setWarehouseValue(event);
      return;
    }

    if (element === "manufacturedby") {
      setEnquiryDetails({
        ...enquiryDetails,
        manufacturedby: event.value,
      });
      return;
    }

    if (element === "customer") {
      setEnquiryDetails({
        ...enquiryDetails,
        customer: {
          id: event.value,
        },
      });
      setCustomerNameValue(event);
      getCustomerDetails(event.value);
      getCustomerAddress(event.value);
      setCustomerAddressValue("");
      return;
    }

    if (element === "customeraddress") {
      setEnquiryDetails({
        ...enquiryDetails,
        customeraddress: {
          id: event.value,
        },
      });
      setCustomerAddressValue(event);
      return;
    }

    const { name, value } = event.target;
    setEnquiryDetails({
      ...enquiryDetails,
      [name]: value,
    });
  };

  const handleGrandTotalCurrency = (netAmountCurrency, miscChargesCurrency) => {
    const total = Number(netAmountCurrency) + Number(miscChargesCurrency);
    console.log(total);

    setEnquiryDetails((prevDetails) => ({
      ...prevDetails,
      grandtotalcurrency: total,
    }));
  };

  const handleGrandTotalInr = (netAmountCurrency, miscChargesCurrency) => {
    const total = Number(netAmountCurrency) + Number(miscChargesCurrency);
    console.log(total);

    setEnquiryDetails((prevDetails) => ({
      ...prevDetails,
      grandtotalinr: total,
    }));
  };

  const calculationsBasedOnExchangeRate = () => {
    let rows = enquiryDetails.salesOrderItems;

    for (let i = 0; i < enquiryDetails.salesOrderItems.length; i++) {
      rows[i].unitrateinr = rows[i].unitratecurrency * rows[i].exchangerate;
      rows[i].totalinr = rows[i].unitrateinr * rows[i].quantity;
    }

    setEnquiryDetails({
      ...enquiryDetails,
      salesOrderItems: rows,
    });

    handleGrandTotal();
  };

  const handleNetTotalCurrency = () => {
    let rows = enquiryDetails.salesOrderItems;
    let netTotal = 0;

    for (let i = 0; i < rows.length; i++) {
      netTotal += rows[i].totalcurrency;
    }

    setEnquiryDetails({
      ...enquiryDetails,
      netamountcurrency: netTotal,
    });
  };

  const handleQuantityChange = (event, index) => {
    let rows = enquiryDetails.salesOrderItems;

    enquiryDetails.netamount = 0;
    rows[index].quantity = event.target.value;

    rows[index].totalcurrency = Number(rows[index].quantity) * Number(rows[index].unitratecurrency);
    rows[index].totalinr = Number(rows[index].quantity) * Number(rows[index].unitrateinr);

    for (let i = 0; i < rows.length; i++) {
      enquiryDetails.netamount += rows[i].totalinr;
    }

    setEnquiryDetails({
      ...enquiryDetails,

      salesOrderItems: rows,
    });

    handleNetTotalCurrency();
  };

  const handleUnitRateChange = (event, index) => {
    let rows = enquiryDetails.salesOrderItems;
    enquiryDetails.netamount = 0;

    rows[index].unitratecurrency = event.target.value;
    rows[index].unitrateinr = rows[index].unitratecurrency * rows[index].exchangerate;
    rows[index].totalcurrency = Number(rows[index].quantity) * Number(rows[index].unitratecurrency);
    rows[index].totalinr = Number(rows[index].quantity) * Number(rows[index].unitrateinr);
    rows[index].totalinr = roundToDecimalPlaces(rows[index].totalinr, 2);

    for (let i = 0; i < rows.length; i++) {
      enquiryDetails.netamount += rows[i].totalinr;
    }

    setEnquiryDetails({
      ...enquiryDetails,
      salesOrderItems: rows,
    });

    handleGrandTotal();
    handleNetTotalCurrency();
  };

  const handleExchangeRateChange = (event, index) => {
    let rows = enquiryDetails.salesOrderItems;

    rows[index].exchangerate = event.target.value;
    rows[index].unitrateinr = rows[index].exchangerate * rows[index].unitratecurrency;
    rows[index].totalinr = rows[index].unitrateinr * rows[index].quantity;

    setEnquiryDetails({
      ...enquiryDetails,
      salesOrderItems: rows,
    });

    handleGrandTotal();
  };

  const handleGrandTotal = () => {
    let nettotal = 0;

    for (let i = 0; i < enquiryDetails.salesOrderItems.length; i++) {
      nettotal += enquiryDetails.salesOrderItems[i].totalinr;
    }

    setEnquiryDetails({
      ...enquiryDetails,
      netamount: nettotal,
    });
  };

  const handleMiscChargesCurrency = (event) => {
    const updatedRows = {
      ...enquiryDetails,
      exportpreperationchargescurrency: event.target.value,
      exportpreperationcharges: enquiryDetails.soexchangerate * event.target.value,
    };
    setEnquiryDetails(updatedRows);
  };

  function handleMiscCharges(event) {
    console.log(event.target.value);
    let miscCharges = parseFloat(event.target.value); // Convert to a number
    console.log(miscCharges, enquiryDetails.gst);

    const gstAmount = (miscCharges * Number(enquiryDetails.gst)) / 100; // Calculate GST
    console.log(gstAmount);

    let netCharges = miscCharges + gstAmount; // Correctly add as numbers
    console.log(netCharges);

    // Ensure netamount is a number before adding
    let netamount = Number(enquiryDetails.netamount) || 0; // Default to 0 if undefined
    let gtotal = roundToDecimalPlaces(netamount + netCharges, 2);

    setEnquiryDetails((prevDetails) => ({
      ...prevDetails,
      exportpreperationcharges: miscCharges,
      netcharges: netCharges,
      grandtotalinr: gtotal,
    }));
  }

  function roundToDecimalPlaces(value, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(value * factor) / factor;
  }

  const removeRow = (idx) => {
    // Filter out the item at the specified index
    const newItems = enquiryDetails.salesOrderItems.filter((_, index) => index !== idx);

    // Update state with the new items
    setEnquiryDetails((prevDetails) => ({
      ...prevDetails,
      salesOrderItems: newItems,
    }));

    // Call handleGrandTotal to recalculate the grand total
    // Pass the updated items
  };

  useEffect(() => {
    getCustomerData();
    getProductData();
    getBranchData();
    getWarehouseData();
    getStaffData();
  }, []);

  useEffect(() => {
    getCustomerData();
  }, [customerSearch]);

  useEffect(() => {
    getProductData();
  }, [productSearch]);

  useEffect(() => {
    getBranchData();
  }, [branchSearch]);

  useEffect(() => {
    getWarehouseData();
  }, [warehouseSearch]);

  useEffect(() => {
    getStaffData();
  }, [staffSearch]);

  //   useEffect(() => {
  //     setEnquiryDetails({
  //       ...enquiryDetails,
  //       exportpreperationcharges: enquiryDetails.soexchangerate * enquiryDetails.exportpreperationchargescurrency,
  //     });
  //   }, [enquiryDetails.soexchangerate, enquiryDetails.exportpreperationchargescurrency]);

  useEffect(() => {
    let netTotal = 0;
    let netTotalCurrency = 0;

    for (let i = 0; i < enquiryDetails?.salesOrderItems?.length; i++) {
      netTotal += enquiryDetails?.salesOrderItems[i]?.totalinr;
      netTotalCurrency += enquiryDetails?.salesOrderItems[i]?.totalcurrency;
    }

    setEnquiryDetails({
      ...enquiryDetails,
      netamount: netTotal,
      netamountcurrency: netTotalCurrency,
    });
  }, [enquiryDetails?.salesOrderItems?.length]);

  useEffect(() => {
    console.log("Updating grand total with:", enquiryDetails.netamountcurrency, enquiryDetails.exportpreperationchargescurrency);
    handleGrandTotalCurrency(enquiryDetails.netamountcurrency, enquiryDetails.exportpreperationchargescurrency);
  }, [enquiryDetails.exportpreperationchargescurrency, enquiryDetails.netamountcurrency]);

  useEffect(() => {
    handleGrandTotalInr(enquiryDetails.netamount, enquiryDetails.exportpreperationcharges);
  }, [enquiryDetails.netamount, enquiryDetails.exportpreperationcharges]);

  useEffect(() => {
    let product = enquiryDetails.soexchangerate * enquiryDetails.exportpreperationchargescurrency;
    setEnquiryDetails({
      ...enquiryDetails,
      exportpreperationcharges: product,
    });
  }, [enquiryDetails.soexchangerate]);

  useEffect(() => {
    const row = enquiryData?.salesOrderItems?.map((data) => ({
      id: data?.id,
      product: {
        id: data?.product?.id,
      },
      description: data?.product?.description,
      productremarks: data?.productremarks,
      itemcode: data?.itemcode,
      hsnsacno: data?.hsnsacno,
      serialnumber: data?.serialnumber,
      modelnumber: data?.modelnumber,
      partno: data?.partno,
      moc: data?.moc,
      uom: data?.uom,
      currency: data?.currency,
      quantity: data?.quantity,
      unitratecurrency: data?.unitratecurrency,
      totalcurrency: data?.totalcurrency,
      exchangerate: data?.exchangerate,
      unitrateinr: data?.unitrateinr,
      totalinr: data?.totalinr,
    }));
    setEnquiryDetails({
      ...enquiryDetails,
      salesordertype: "Manufacturing",
      salesordercategory: "International",
      branch: {
        id: enquiryData?.branch?.id,
      },
      warehouse: {
        id: enquiryData?.warehouse?.id,
      },
      sodate: enquiryData?.sodate,
      amendmentno: enquiryData?.amendmentno,
      amendmentdate: enquiryData?.amendmentdate,
      customer: {
        id: enquiryData?.customer?.id,
      },
      contactperson: enquiryData?.contactperson,
      contactno: enquiryData?.contactno,
      email: enquiryData?.email,
      customeraddress: {
        id: enquiryData?.customeraddress?.id,
      },
      customerpono: enquiryData?.customerpono,
      customerpodate: enquiryData?.customerpodate,
      quotationno: enquiryData?.quotationno,
      quotationdate: enquiryData?.quotationdate,
      netamountcurrency: enquiryData?.netamountcurrency,
      netamount: enquiryData?.netamount,
      exportpreperationchargescurrency: enquiryData?.exportpreperationchargescurrency,
      exportpreperationcharges: enquiryData?.exportpreperationcharges,
      grandtotalcurrency: enquiryData?.grandtotalcurrency,
      grandtotalinr: enquiryData?.grandtotalinr,
      salesOrderItems: row,
      socurrency: enquiryData?.socurrency,
      soexchangerate: enquiryData?.soexchangerate,
      sono: enquiryData?.sono,
      status: enquiryData?.status,
      quotationid: enquiryData?.quotationid,
      deliveryterm: enquiryData?.deliveryterm,
      incoterm: enquiryData?.incoterm,
      paymentterm: enquiryData?.paymentterm,
    });

    setBranchValue({ value: enquiryData?.branch?.id, label: enquiryData?.branch?.branchname });
    setWarehouseValue({ value: enquiryData?.warehouse?.id, label: enquiryData?.warehouse?.warehousename });
    setCustomerNameValue({ value: enquiryData?.customer?.id, label: enquiryData?.customer?.companyname });
    setCustomerAddressValue({ value: enquiryData?.customerAddressValue?.id, label: enquiryData?.customeraddress?.customeraddress });

    getCustomerAddress(enquiryData?.customeraddress?.id);
  }, []);

  console.log(enquiryDetails);
  return (
    <Form>
      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Branch</Form.Label>
            <Select
              isDisabled
              options={branchOptions}
              onChange={(event) => handleFormChange(event, "branch")}
              onInputChange={(event) => {
                setBranchSearch(event);
              }}
              value={branchValue}
            />
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Warehouse</Form.Label>
            <Select
              isDisabled
              options={warehouseOptions}
              onChange={(event) => handleFormChange(event, "warehouse")}
              onInputChange={(event) => {
                setWarehouseSearch(event);
              }}
              value={warehouseValue}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Sales Order No.</Form.Label>
            <Form.Control disabled type="text" name="sodate" value={enquiryDetails.sono} onChange={handleFormChange} />
          </Form.Group>
        </Col>

        <Col md="6">
          <Form.Group>
            <Form.Label>Sales Order Date</Form.Label>
            <Form.Control disabled type="date" name="sodate" value={enquiryDetails.sodate} onChange={handleFormChange} />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Amendment Date</Form.Label>
            <Form.Control disabled type="date" name="amendmentdate" value={enquiryDetails.amendmentdate} onChange={handleFormChange} />
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Amendment No.</Form.Label>
            <Form.Control disabled type="text" name="amendmentno" value={enquiryDetails.amendmentno} onChange={handleFormChange} placeholder="Amendment No." />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col>
          <Form.Group>
            <Form.Label>Customer Name</Form.Label>
            <Select
              isDisabled
              options={customerOptions}
              onChange={(event) => handleFormChange(event, "customer")}
              onInputChange={(event) => {
                setCustomerSearch(event);
              }}
              value={customerNameValue}
            />
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Contact Person</Form.Label>
            <Form.Control value={enquiryDetails.contactperson} disabled />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Contact Number</Form.Label>
            <Form.Control value={enquiryDetails.contactno} disabled />
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control value={enquiryDetails.email} disabled />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Payment Terms</Form.Label>
            <Form.Control disabled type="text" name="paymentterm" value={enquiryDetails.paymentterm} onChange={handleFormChange} placeholder="Payment Terms" />
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Customer Address</Form.Label>
            <Select isDisabled value={customerAddressValue} options={customerDetailsOptions} onChange={(event) => handleFormChange(event, "customeraddress")} />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Customer PO NO.</Form.Label>
            <Form.Control disabled type="text" name="customerpono" value={enquiryDetails.customerpono} onChange={handleFormChange} placeholder="Customer PO NO." />
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Customer PO Date</Form.Label>
            <Form.Control disabled type="date" name="customerpodate" value={enquiryDetails.customerpodate} onChange={handleFormChange} placeholder="Customer PO Date" />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Quotation NO.</Form.Label>
            <Form.Control disabled type="text" name="quotationno" value={enquiryDetails.quotationno} onChange={handleFormChange} placeholder="Quotation NO." />
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Quotation Date</Form.Label>
            <Form.Control disabled type="date" name="quotationdate" value={enquiryDetails.quotationdate} onChange={handleFormChange} placeholder="Quotation Date" />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Delivery Terms</Form.Label>
            <Form.Control disabled type="text" name="deliveryterm" value={enquiryDetails.deliveryterm} onChange={handleFormChange} placeholder="Delivery Terms" />
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Inco Terms</Form.Label>
            <Form.Control disabled type="text" name="incoterm" value={enquiryDetails.incoterm} onChange={handleFormChange} placeholder="Inco Terms" />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Currency</Form.Label>
            <Form.Select disabled onChange={(e) => handleFormChange(e, "socurrency")} name="socurrency" value={enquiryDetails.socurrency}>
              <option>Select Currency</option>
              <option value="$ (USD)">$ (USD)</option>
              <option value="Euro (Eurpeen Dollar)">Euro (Eurpeen Dollar)</option>
              <option value="GBP (Pounds)">GBP (Pounds)</option>
              <option value="JPY (Japanese Yen)">JPY (Japanese Yen)</option>
              <option value="₹ (INR)">₹ (INR)</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md="6">
          <Form.Group>
            <Form.Label>Exchange Rate (Rs)/Currency</Form.Label>
            <Form.Control disabled type="number" onChange={(e) => handleFormChange(e, "soexchangerate")} value={enquiryDetails.soexchangerate} name="soexchangerate" />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Control disabled type="text" onChange={(e) => handleFormChange(e, "soexchangerate")} value={enquiryDetails.status} name="soexchangerate" />
          </Form.Group>
        </Col>
      </Row>

      <br></br>
      <hr></hr>

      <br></br>
      <div className="table-responsive">
        <Table>
          <thead>
            <tr>
              <th>Product Description</th>
              <th>Product Code</th>
              <th>HSN Code</th>
              <th>Serial No.</th>
              <th>Model No.</th>
              <th>Part No.</th>
              <th>MOC</th>
              <th>unit of measurement</th>
              <th>Currency</th>
              <th>Quantity</th>
              <th>Unit Rate (Currency)</th>
              <th>Total (Currency) </th>
              <th>Exchange Rate (Rs)/Currency</th>
              <th>Unit Rate (Rs)</th>
              <th>Total (Rs)</th>
            </tr>
          </thead>
          <tbody>
            {enquiryDetails.salesOrderItems.map((item, index) => (
              <tr key={index}>
                <td>
                  {item.description}
                  <Form.Control
                    disabled
                    as="textarea"
                    rows={2}
                    className="remarks"
                    type="text"
                    value={item.productremarks}
                    onChange={(e) => {
                      const newRows = [...enquiryDetails.salesOrderItems];
                      newRows[index].productremarks = e.target.value;
                      setEnquiryDetails({ ...enquiryDetails, salesOrderItems: newRows });
                    }}
                    placeholder="Enter item remarks"
                    contentEditable="true"
                  />
                </td>
                <td>{item.itemcode}</td>
                <td>{item.hsnsacno}</td>
                <td>{item.serialnumber}</td>
                <td>{item.modelnumber}</td>
                <td>{item.partno}</td>
                <td>{item.moc}</td>
                <td>
                  <Form.Select
                    className="uom"
                    disabled
                    value={item.uom ? item.uom.toLowerCase() : ""}
                    onChange={(event) => {
                      // Update the unit of measurement in the respective item
                      const newItems = [...enquiryDetails.enquiryItems];
                      newItems[index].uom = event.target.value; // Store the selected value as is
                      setEnquiryDetails({ ...enquiryDetails, enquiryItems: newItems });
                    }}
                  >
                    <option value="">Select UOM</option>
                    <option value="bot (bottle)">Bot (Bottle)</option>
                    <option value="ctn (carton)">Ctn (Carton)</option>
                    <option value="days">Days</option>
                    <option value="ft (feet)">Ft (FEET)</option>
                    <option value="hrs (hour)">Hrs (Hour)</option>
                    <option value="kg (kilogram)">Kg (Kilogram)</option>
                    <option value="kgs.">Kgs.</option>
                    <option value="ltr (littre)">Ltr (Littre)</option>
                    <option value="mtr">Mtr</option>
                    <option value="nos (number)">Nos (Number)</option>
                    <option value="pil (pail)">Pil (Pail)</option>
                    <option value="pkt (packet)">Pkt (Packet)</option>
                    <option value="set (sets)">Set (Sets)</option>
                    <option value="pcs (pcs)">Pcs (Pcs)</option>
                  </Form.Select>
                </td>
                <td>
                  <Form.Control className="uom" value={item?.currency} disabled />
                </td>
                <td>
                  <Form.Control min="0" className="uom" value={item.quantity} disabled type="number" onChange={(event) => handleQuantityChange(event, index)} />
                </td>

                <td>
                  <Form.Control min="0" className="uom" type="number" disabled onChange={(event) => handleUnitRateChange(event, index)} value={item.unitratecurrency} />
                </td>

                <td>
                  <Form.Control min="0" className="uom" type="number" value={item.totalcurrency} disabled />
                </td>

                <td>
                  <Form.Control min="0" className="uom" type="number" value={item?.exchangerate} disabled onChange={(event) => handleExchangeRateChange(event, index)} />
                </td>

                <td>
                  <Form.Control min="0" className="uom" type="number" value={item.unitrateinr} disabled />
                </td>

                <td>
                  <Form.Control style={{ width: "70px" }} min="0" className="uom" type="text" disabled value={item.totalinr} />
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Net Total (Currency)</td>
              <td>
                <Form.Control min="0" className="uom" type="number" disabled value={enquiryDetails.netamountcurrency} />
              </td>
              <td></td>
              <td>Net Total (Rs)</td>
              <td>
                <Form.Control min="0" className="uom" type="number" disabled value={enquiryDetails.netamount} />
              </td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Export Prepration Charges (Currency)</td>
              <td>
                <Form.Control disabled min="0" className="uom" type="number" onChange={(event) => handleMiscChargesCurrency(event)} value={enquiryDetails.exportpreperationchargescurrency} />
              </td>
              <td></td>
              <td>Export Prepration Charges (Rs)</td>
              <td>
                <Form.Control min="0" className="uom" type="number" disabled onChange={(event) => handleMiscCharges(event)} value={enquiryDetails.exportpreperationcharges} />
              </td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Grand Total (Currency)</td>
              <td>
                <Form.Control min="0" className="uom" type="number" disabled value={enquiryDetails.grandtotalcurrency} />
              </td>
              <td></td>
              <td>Grand Total (Rs)</td>
              <td>
                <Form.Control min="0" className="uom" type="number" disabled value={enquiryDetails.grandtotalinr} />
              </td>
              <td></td>
            </tr>
          </tfoot>
        </Table>
      </div>
    </Form>
  );
};

export default ViewAraiMFGSO;
